const summary_cards = [
  { label: 'USERS', value: '8', note: 'Active accounts', tone: 'primary' },
  { label: 'APPROVERS & ADMINS', value: '4', note: 'Elevated access', tone: 'warning' },
  { label: 'MFA COVERAGE', value: '88%', note: '1 without MFA', tone: 'success' },
  { label: 'ACCESS REVIEWS', value: '1 due', note: 'Privileged accounts', tone: 'danger' }
];

const tabs = [
  { id: 'users', label: 'Users', count: 8 },
  { id: 'permissions', label: 'Role permissions', count: 4 },
  { id: 'access-map', label: 'Access map', count: 5 }
];

const users = [
  { initials: 'PN', name: 'Pearl Naidoo', role: 'Chief Compliance Officer', department: 'Legal & Compliance', access: 'Administrator', mfa: 'On', status: { label: 'Active', class: 'bg-success-subtle text-success-emphasis' } },
  { initials: 'MK', name: 'M. Khan', role: 'Chief Financial Officer', department: 'Finance', access: 'Approver', mfa: 'On', status: { label: 'Active', class: 'bg-success-subtle text-success-emphasis' } },
  { initials: 'RG', name: 'R. Govender', role: 'CISO', department: 'IT Security', access: 'Approver', mfa: 'On', status: { label: 'Active', class: 'bg-success-subtle text-success-emphasis' } },
  { initials: 'SK', name: 'S. Khumalo', role: 'SCM Manager', department: 'Procurement', access: 'Contributor', mfa: 'On', status: { label: 'Active', class: 'bg-success-subtle text-success-emphasis' } },
  { initials: 'JM', name: 'J. Moyo', role: 'Accounts Payable', department: 'Finance', access: 'Contributor', mfa: 'Off', status: { label: 'Review', class: 'bg-warning-subtle text-warning-emphasis' } },
  { initials: 'AdW', name: 'A. de Wet', role: 'Legal Counsel', department: 'Legal & Compliance', access: 'Contributor', mfa: 'On', status: { label: 'Active', class: 'bg-success-subtle text-success-emphasis' } },
  { initials: 'KS', name: 'K. Sithole', role: 'Procurement Officer', department: 'Procurement', access: 'Contributor', mfa: 'On', status: { label: 'Restricted', class: 'bg-danger-subtle text-danger-emphasis' } },
  { initials: 'TM', name: 'T. Mthembu', role: 'Information Officer', department: 'Legal & Compliance', access: 'Approver', mfa: 'On', status: { label: 'Active', class: 'bg-success-subtle text-success-emphasis' } }
];

const access_map = [
  { label: 'Approver', detail: 'Can approve workflow steps, policy changes and board items.' },
  { label: 'Contributor', detail: 'Can add evidence, update registers and draft items.' },
  { label: 'Administrator', detail: 'Can manage system configuration, users and permissions.' },
  { label: 'Viewer', detail: 'Read-only access to dashboards and reports.' },
  { label: 'Restricted', detail: 'Temporarily blocked until review is completed.' }
];

export default {
  name: 'UsersRoles',
  data: () => ({
    summary_cards,
    tabs,
    users,
    access_map,
    active_tab: 'users'
  }),
  methods: {
    set_tab(tab_id) {
      this.active_tab = tab_id;
    }
  }
};
